import { createSlice } from "@reduxjs/toolkit";
import { getComplianceObjectReducerBuilder } from "./reducers";
import type { ComplianceState } from "./types";

const initialState: ComplianceState = {
  compliance: null,
};

const complianceSlice = createSlice({
  name: "compliance",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    getComplianceObjectReducerBuilder(builder);
  },
});

export const complianceReducers = complianceSlice.reducer;
